import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

interface Item {
  text: string;
  onClick?: () => any;
}

interface Props extends React.BaseHTMLAttributes<HTMLDivElement> {
  items: Item[];
  currentIndex?: number;
}

const ButtonsSwitch: React.FC<Props> = ({
  items,
  currentIndex = 0,
  ...props
}) => {
  const [activeIndex, setActiveIndex] = React.useState(currentIndex);

  const renderButton = (item, index) => {
    const handleClick = (event) => {
      setActiveIndex(index);

      if (!item.onClick) return;
      return item.onClick(event);
    };
    return (
      <button
        onClick={handleClick}
        className={classNames({ [styles.active]: activeIndex === index })}
        key={index}
        aria-label={item.text}
      >
        {item.text}
      </button>
    );
  };

  const indicatorStyles = {
    width: `calc(100% / ${items.length})`,
    transform: `translateX(calc(100% * ${activeIndex}))`,
  };

  return (
    <div
      className={classNames([styles.indicator__container, props.className])}
      itemScope
      itemType='https://schema.org/Thing'
    >
      <div className={styles.indicator} style={indicatorStyles} />
      <div
        className={styles.indicator__list}
        style={{ gridTemplateColumns: `repeat(${items.length}, 1fr)` }}
      >
        {items.map(renderButton)}
      </div>
    </div>
  );
};

export default ButtonsSwitch;
